export const notificationCenterTheme = {
  notificationItem: {
    bottomBorder: 'palette.tertiary.10',
    creationDate: {
      text: 'palette.tertiary.40',
    },
    expandedBg: 'palette.tertiary.10',
    unreadTag: {
      bg: 'palette.primary.10',
      text: 'palette.neutral.80',
    },
  },
  notificationList: {
    dateGroupLabel: {
      text: 'palette.tertiary.60',
    },
  },
};
